<template>
<div class="ac" style="padding-top: 20px">
    <div v-for="(card, index) in cards" :key="index" class="card col-auto">
        <iv :class="card.icon"></iv>
        <div class="number" :data-target-number="card.targetNumber">{{ card.count }}</div>
        {{ card.title }}
    </div>
    <section1>
        <div style="display: grid; place-items: center;">
            <img src="../assets/images/code.png" height="150" alt="">
        </div>

        <div class="wave water"></div>
        <div class="wave water"></div>
        <div class="wave water"></div>
        <div class="wave water"></div>
    </section1>
</div>
</template>

<script>
export default {
    data() {
        return {
            cards: [{
                    icon: "fab fa-linkedin",
                    title: "Linkedin community",
                    targetNumber: 2000,
                    count: 0,
                },
                {
                    icon: "fa fa-user-plus",
                    title: "Connections",
                    targetNumber: 5000,
                    count: 0,
                },
                {
                    icon: "fas fa-bolt",
                    title: "Internship Enroll",
                    targetNumber: 1000,
                    count: 0,
                },
                {
                    icon: "fas fa-check",
                    title: "Projects Done",
                    targetNumber: 200,
                    count: 0,
                },
            ],
        };
    },
    mounted() {
        this.animateNumbers();
    },
    methods: {
        animateNumbers() {
            this.cards.forEach((card) => {
                const target = card.targetNumber;
                const duration = 2000;
                const step = Math.ceil(target / (duration / 16));

                const updateCount = () => {
                    card.count += step;
                    if (card.count < target) {
                        requestAnimationFrame(updateCount);
                    } else {
                        card.count = target;
                    }
                };

                updateCount();
            });
        },
    },
};
</script>

<style>
.ac {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: center;
}

.card {
    text-align: center;
    font-weight: bold;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease-in-out;
    width: 200px !important;
    /* Set a fixed width */
    height: 170px !important;
    /* Set a fixed height */
    display: flex;
    background-color: rgb(252, 252, 175) !important;
    flex-direction: column;
    justify-content: space-between;
    /* Adjust content alignment */
}

.card:hover {
    transform: scale(1.05);
}

iv {
    font-size: 30px;
    margin-bottom: 10px;
    color: rgb(0, 0, 0);
}

.number {
    font-size: 28px;
    font-weight: bold;
    color: #4caf50;
    margin-bottom: 10px;
}

section1 {
    position: relative;
    width: 100%;
    height: 30vh;
    background: linear-gradient(-45deg, #ee5425, #e71364, #089acf, #0bcea0);
    overflow: hidden;
    background-size: 400% 400%;
    animation: gradient-bg 15s ease infinite;
}

section1 .wave {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100px;
    background: url(../assets/images/wave.png);
    background-size: 1000px 100px;
}

@keyframes gradient-bg {
    0% {
        background-position: 0% 50%;
    }

    50% {
        background-position: 100% 50%;
    }

    100% {
        background-position: 0% 50%;
    }
}

section1 .wave.water {
    animation: animate 25s linear infinite;
    z-index: 1000;
    opacity: 1;
    animation-delay: 0s;
    bottom: 0;
}

section1 .wave.water:nth-child(2) {
    animation: animate2 15s linear infinite;
    z-index: 999;
    opacity: 0.5;
    animation-delay: -5s;
    bottom: 10px;
}

section1 .wave.water:nth-child(3) {
    animation: animate 30s cubic-bezier(.55, .5, .45, .5) infinite;
    z-index: 998;
    opacity: 0.2;
    animation-delay: -5s;
    bottom: 15px;
}

section1 .wave.water:nth-child(4) {
    animation: animate2 5s linear infinite;
    z-index: 997;
    opacity: 0.7;
    animation-delay: -5s;
    bottom: 20px;
}

@keyframes animate {
    0% {
        background-position-x: 0;
    }

    100% {
        background-position-x: 1000px;
    }
}

@keyframes animate2 {
    0% {
        background-position-x: 0;
    }

    100% {
        background-position-x: -1000px;
    }
}









</style>
